import { render } from "./ChatSessionList.vue?vue&type=template&id=2e8b4564&scoped=true"
import script from "./_ChatSessionList.js?vue&type=script&lang=js"
export * from "./_ChatSessionList.js?vue&type=script&lang=js"

import "./_ChatSessionList.less?vue&type=style&index=0&id=2e8b4564&lang=less&scoped=true"

import exportComponent from "/home/aichat/aichat-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8b4564"]])

export default __exports__